'use strict';
import { observable } from 'mobx';

class DeviceInfoStore {
  @observable deviceId = '';
}
export default new DeviceInfoStore();



// WEBPACK FOOTER //
// ./src/store/DeviceInfo/DeviceInfo.js